export type SortDirection = "asc" | "desc";

/** Ordenação de uma coluna: campo (união literal da tela) e direção. Sem ordem, `null`. */
export interface PaginatedSort<F extends string = string> {
  field: F;
  direction: SortDirection;
}

/** Parâmetros que o bff aceita em toda listagem paginada. `sort_direction` só vai com `sort_by`. */
export type PaginatedQuery = {
  page?: number;
  pageSize?: number;
  sort_by?: string;
  sort_direction?: SortDirection;
};

/** Estado da listagem como o gateway o recebe: `page` base 1 (o do HubTable é base 0), tamanho e ordem. */
export interface PaginatedRequest {
  page?: number;
  pageSize?: number;
  sort?: PaginatedSort | null;
}

export interface PaginationMeta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

/** Formato A: o bff remonta o envelope, itens em `data` e o total em `meta.pagination`. */
export interface PaginatedResponseA<T> {
  data: T[];
  meta: { pagination: PaginationMeta };
}

/** Formato B: o bff repassa o core, itens e total em `data` (`totaisPorStatus` nas listas de obras). */
export interface PaginatedResponseB<T> {
  data: { items: T[]; total: number; totaisPorStatus?: Record<string, number> };
  meta?: { pagination?: PaginationMeta };
}

export type PaginatedResponse<T> = PaginatedResponseA<T> | PaginatedResponseB<T>;

/**
 * Estado da listagem → query do contrato. Sem ordem, nem `sort_by` nem
 * `sort_direction` saem. Exportação passa só `sort`: sem `page`/`pageSize`, o
 * arquivo sai completo.
 */
export function toPaginatedQuery({ page, pageSize, sort }: PaginatedRequest): PaginatedQuery {
  const query: PaginatedQuery = {};

  if (page !== undefined) query.page = page;
  if (pageSize !== undefined) query.pageSize = pageSize;

  if (sort) {
    query.sort_by = sort.field;
    query.sort_direction = sort.direction;
  }

  return query;
}
